import { getColor, getSize } from '../../hooks';
import styled from 'styled-components';
export var StyledHeadTitle = styled.h1.withConfig({
  displayName: "head-title__StyledHeadTitle",
  componentId: "sc-1ohv6sm-0"
})(["font-size:", ";font-weight:600;color:", ";margin:0;"], getSize('typo24'), getColor('fillIntActive'));